import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {borderRadius, flexAbsoluteCenter, flexDirection, mb, p, ph, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {bigDataLink} from "../../../navigation/constants/links";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";

export const PricesBigDataReferral = () => {
    return (
        <Container css={mb(9)}>
            <div css={bigDataSectionHolder}>
                <Text as="p" variant="headline_2" align="center" css={mb(2)}>
                    Potrzebujesz profesjonalnych danych?
                </Text>
                <Text variant="body_copy_0" align="center" css={mb(3)}>
                    Nasza platforma BigData prezentuje aktualne, zagregowane dane na podstawie 4000 monitorowanych inwestycji mieszkaniowych rocznie,
                    zamieszczanych na portalu {concatWithBrandName("")}, realizowanych przez ponad 1000 deweloperów w całej Polsce.
                </Text>
                <Button
                    onClick={() => pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.BIG_DATA_CLICK)}
                    variant="filled_primary"
                    href={bigDataLink}
                    target="_blank"
                    css={ph(4)}
                >
                    <Text variant="button_medium">przejdź do bigdata</Text>
                </Button>
            </div>
        </Container>
    );
};

const bigDataSectionHolder = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${p(8, 2)};
    ${w100};
    border: 1px solid ${theme.colors.gray[400]};
    ${borderRadius(2)};

    & > p {
        max-width: 800px;
    }
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {borderRadius, flexAbsoluteCenter, flexDirection, mb, p, ph, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {bigDataLink} from "../../../navigation/constants/links";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";

export const PricesBigDataReferral = () => {
    return (
        <Container css={mb(9)}>
            <div css={bigDataSectionHolder}>
                <Text as="p" variant="headline_2" align="center" css={mb(2)}>
                    Potrzebujesz profesjonalnych danych?
                </Text>
                <Text variant="body_copy_0" align="center" css={mb(3)}>
                    Nasza platforma BigData prezentuje aktualne, zagregowane dane na podstawie 4000 monitorowanych inwestycji mieszkaniowych rocznie,
                    zamieszczanych na portalu {concatWithBrandName("")}, realizowanych przez ponad 1000 deweloperów w całej Polsce.
                </Text>
                <Button
                    onClick={() => pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.BIG_DATA_CLICK)}
                    variant="filled_primary"
                    href={bigDataLink}
                    target="_blank"
                    css={ph(4)}
                >
                    <Text variant="button_medium">przejdź do bigdata</Text>
                </Button>
            </div>
        </Container>
    );
};

const bigDataSectionHolder = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${p(8, 2)};
    ${w100};
    border: 1px solid ${theme.colors.gray[400]};
    ${borderRadius(2)};

    & > p {
        max-width: 800px;
    }
`;
